import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DistrictSelectModalComponent } from '../../../core/district-select-modal/district-select-modal.component';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { AddressCategoryTypeEnumValues } from '../../../enum/type/address-category-type.enum';
import { Address } from '../../../models/entity/address';
import { AddressService } from '../../../services/core/address.service';
import { AlertifyService } from '../../../services/core/alertify.service';
import { NumberUtils } from '../../../utils/number.utils';

@Component({
  selector: 'app-address-add-update',
  templateUrl: './address-add-update.component.html',
  styleUrls: ['./address-add-update.component.css']
})
export class AddressAddUpdateComponent implements OnInit {

  @Input() data: Address;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  addressCategoryTypeEnumValues = AddressCategoryTypeEnumValues;


  constructor(
    private addressService: AddressService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private alertifyService: AlertifyService) { }

  ngOnInit(): void {
  }

  //güncelle veya yeni kayıt ekle
  save() {

    if (!this.validateSave())
      return;
    //Yeni kayıt ise
    if (!this.data.id) {
      this.add();
    }
    //Var olan kaydı güncelle
    else {
      this.update();
    }
  }
  //kontroller
  validateSave() {
    if (NumberUtils.isNotGreaterThanZero(this.data.cityId)) {
      this.alertifyService.error(this.translate.instant('message.warning.please-select-city'));
      return false;
    }

    return true;
  }

  // yeni kayıt ekle
  add() {
    this.addressService.addAddress(this.data).subscribe(
      (res) => {
        this.data = res;
        this.alertifyService.success(this.translate.instant('message.info.saved'));
        this.passEntry.emit(this.data);

      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  // güncelle
  update() {
    this.addressService
      .updateAddress(this.data.id, this.data)
      .subscribe(
        (res) => {
          this.data = res;
          this.alertifyService.success(this.translate.instant('message.info.updated'));
          this.passEntry.emit(this.data);
        },
        (err) => {
          this.alertifyService.error(err);
        }
      );
  }



  //semt seçimi
  openSelectDistrictModal() {
    const modalRef = this.modalService.open(DistrictSelectModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM
    });
    //modal  veri geçişi
    modalRef.componentInstance.countryId = this.data.countryId;
    modalRef.componentInstance.cityId = this.data.cityId;
    modalRef.componentInstance.subProvinceId = this.data.subProvinceId;
    modalRef.componentInstance.districtId = this.data.districtId;

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {
        this.data.countryId = receivedEntry.countryId;
        this.data.countryName = receivedEntry.countryName;
        this.data.cityId = receivedEntry.cityId;
        this.data.cityName = receivedEntry.cityName;
        this.data.subProvinceId = receivedEntry.subProvinceId;
        this.data.subProvinceName = receivedEntry.subProvinceName;
        this.data.districtId = receivedEntry.districtId;
        this.data.districtName = receivedEntry.districtName;
      }

      // modal kapat
      modalRef.close();
    });

  }
  close() {
    this.passEntry.emit();
  }
}
